import React from 'react';

import { List, ListItem } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { Translate, TranslateFunction } from 'react-localize-redux';

import { Button } from '@fd/ui/atoms/Button';
import { Typography } from '@fd/ui/atoms/Typography';
import { Dialog } from '@fd/ui/molecules/Dialog';

const useStyles = makeStyles((theme: Theme) => ({
  confirmButton: {
    backgroundColor: '#FF2346',
    marginLeft: theme.spacing(1.25),
    '&:hover': {
      backgroundColor: '#c91836',
    },
  },
  dialogText: {
    color: theme.palette.grey[700],
  },
  list: {
    listStyle: 'disc',
    marginLeft: theme.spacing(1.5),
    marginBottom: theme.spacing(3),
  },
  listItem: {
    display: 'list-item',
    padding: 0,
    color: theme.palette.grey[700],
  },
  listText: {
    color: 'inherit',
  },
}));

export type UnpublishConfirmationDialogProps = {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  translate: TranslateFunction;
};

export const UnpublishConfirmationDialog = (
  props: UnpublishConfirmationDialogProps
): JSX.Element => {
  const { open, onCancel, onConfirm, translate } = props;

  const classes = useStyles();

  return (
    <Dialog
      title={translate('MobileApps_unpublishDialog_title') as string}
      open={open}
      onClose={onCancel}
      actions={[
        <Button key="cancel-unpublish" fdKey="cancel-unpublish" onClick={onCancel} variant="text">
          {translate('Cancel')}
        </Button>,
        <Button
          className={classes.confirmButton}
          key="confirm-unpublish"
          fdKey="confirm-unpublish"
          onClick={onConfirm}
        >
          {translate('Unpublish')}
        </Button>,
      ]}
    >
      <Typography className={classes.dialogText} variant="body1">
        <Translate id="Do_this_if" />
      </Typography>
      <List className={classes.list}>
        <ListItem className={classes.listItem}>
          <Typography className={classes.listText} variant="body2">
            <Translate id="You_are_not_ready_to_accept_orders_yet" />
          </Typography>
        </ListItem>
        <ListItem className={classes.listItem}>
          <Typography className={classes.listText} variant="body2">
            <Translate id="You_will_publish_app_again_in_future" />
          </Typography>
        </ListItem>
      </List>
      <Typography className={classes.dialogText} variant="body1">
        <Translate id="It_will_mean" />
      </Typography>
      <List className={classes.list}>
        <ListItem className={classes.listItem}>
          <Typography className={classes.listText} variant="body2">
            <Translate id="MobileApps_unpublishDialog_appNotInAppStore" />
          </Typography>
        </ListItem>
        <ListItem className={classes.listItem}>
          <Typography className={classes.listText} variant="body2">
            <Translate id="MobileApps_unpublishDialog_notAbleToOrder" />
          </Typography>
        </ListItem>
        <ListItem className={classes.listItem}>
          <Typography className={classes.listText} variant="body2">
            <Translate id="MobileApps_unpublishDialog_loseRevenue" />
          </Typography>
        </ListItem>
      </List>
    </Dialog>
  );
};
